<div>
  <h2 *ngIf="title > ''" class="title">{{title}}</h2>
  <h2 *ngIf="client && client.name > ''" class="flex">Cliente: <span class="blurred">{{client.name}} {{appSvc.deviceType !== 'handset' ? '(' + client.domain + ')' : ''}}</span></h2>
</div>
